'use client';

import { Icons } from '@commenda/kakashi';

import { EntryCompletenessHelper } from '../../utils/entry-completeness-helper';
import type { EntryCompletenessStatus } from '../../utils/entry-completeness.types';

interface EntryCompletenessStatusTextProps {
  status: EntryCompletenessStatus;
}

/** The line under a selected person or entity saying why it cannot be accepted yet. */
export const EntryCompletenessStatusText = ({
  status,
}: EntryCompletenessStatusTextProps) => {
  if (status.kind === 'checking') {
    return (
      <p className="mt-xxs txt-xs-regular text-text-tertiary">
        Checking details…
      </p>
    );
  }
  return (
    <p className="mt-xxs flex items-center gap-xs txt-xs-regular text-text-warning">
      <Icons.AlertCircle className="size-3.5 shrink-0" />
      <span className="truncate">
        {status.kind === 'unchecked'
          ? "Couldn't check details"
          : `Missing details: ${EntryCompletenessHelper.formatMissingFieldsSummary(status.missingFields)}`}
      </span>
    </p>
  );
};
